import * as CONSTANTS from '../constants/constants';

export const getPosts = () => (
  dispatch,
  getState,
  { getFirestore }
) => {
  const firestore = getFirestore();
  const posts = [];
  const postRef = firestore.collection(CONSTANTS.POST).where("asDraft", "==", false);

  postRef.get().then((querySnapshot) => {
    // console.log('getting...')
    querySnapshot.forEach((post) => {
      posts.push(Object.assign(post.data(), { id: post.id }));
    });
    // console.log(posts)
    dispatch({ type: CONSTANTS.GET_POSTS, posts });
  }).catch((e) => {
    // eslint-disable-next-line no-console
    console.log('error', e);
  });
};

export const getCatPosts = (slug) => (
  dispatch,
  getState,
  { getFirestore }
) => {
  const firestore = getFirestore();
  const posts = [];
  const postRef = firestore.collection(CONSTANTS.POST).where("asDraft", "==", false).where("postcategory", "array-contains", slug);

  postRef.get().then((querySnapshot) => {
    // console.log('getting...')
    querySnapshot.forEach((post) => {
      posts.push(Object.assign(post.data(), { id: post.id }));
    });
    // console.log(posts)
    dispatch({ type: CONSTANTS.GET_CAT_POSTS, posts });
  }).catch((e) => {
    // eslint-disable-next-line no-console
    console.log('error', e);
  });
};

export const getPost = postId => (
  dispatch,
  getState,
  { getFirestore }
) => {
  const firestore = getFirestore();
  const postRef = firestore.collection(CONSTANTS.POST).where("slug", "==", postId);
  postRef.get().then((snapshot) => {
    if (snapshot.empty) {
      dispatch({ type: CONSTANTS.SHOWERROR_PAGEBLOG })
    } else {
      snapshot.forEach((doc) => {
        const post = Object.assign(doc.data(), { id: doc.id });
        // console.log(post)
        dispatch({ type: CONSTANTS.GET_POST, post });
      })
    }
  }).catch((e) => {
    console.log('error', e);
  });
};

export const getPostCats = () => (
  dispatch,
  getState,
  { getFirestore }
) => {
  const firestore = getFirestore();
  const postcats = [];
  const postcatRef = firestore.collection(CONSTANTS.POSTCAT);

  postcatRef.get().then((querySnapshot) => {
    // console.log('getting...')
    querySnapshot.forEach((postcat) => {
      postcats.push(Object.assign(postcat.data(), { id: postcat.id }));
    });
    // console.log(postcats)
    dispatch({ type: CONSTANTS.GET_POSTCATS, postcats });
  }).catch((e) => {
    console.log('error', e);
  });
};

export const getPostCat = postcatId => (
  dispatch,
  getState,
  { getFirestore }
) => {
  const firestore = getFirestore();
  const postcatRef = firestore.collection(CONSTANTS.POSTCAT).where("slug", "==", postcatId);
  postcatRef.get().then((snapshot) => {
    snapshot.forEach((doc) => {
      const postcat = Object.assign(doc.data(), { id: doc.id });
      // console.log('getting')
      dispatch({ type: CONSTANTS.GET_POSTCAT, postcat });
    })
  }).catch((e) => {
    console.log('error', e);
  });
};

export const getPostCommenrts = postId => (
  dispatch,
  getState,
  { getFirestore }
) => {
  const comments = [];
  const firestore = getFirestore();
  const postRef = firestore.collection(CONSTANTS.POST)
  const findComment = postRef.where("slug", "==", postId)

  findComment.get().then((snap) => {
    snap.forEach((doc) => {
      const commentRef = postRef.doc(doc.id).collection('comments');
      commentRef.get().then((querySnapshot) => {
        querySnapshot.forEach((comment) => {
          comments.push(Object.assign(comment.data(), { id: comment.id, subcomments: [] }));
        });
        comments.map((comment) => {
          const subcommentRef = commentRef.doc(comment.id).collection('subcomments');
          subcommentRef.get().then((subcomments) => {
            subcomments.forEach((subcomment) => {
              comment.subcomments.push(Object.assign(subcomment.data(), { id: subcomment.id }));
            });
          });
          return comments;
        });
        dispatch({ type: CONSTANTS.GET_COMMENTS, comments });
      })
        .catch((e) => {
          // eslint-disable-next-line no-console
          console.log('error', e);
        });
    })
  })
};
